import { render } from "./FiltroPeriodo.vue?vue&type=template&id=79ed0e78"
import script from "./FiltroPeriodo.vue?vue&type=script&lang=js"
export * from "./FiltroPeriodo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__